/* eslint-disable no-underscore-dangle */
/* eslint camelcase: ["error", {properties: "never"}] */

import { trygTealiumLib } from './trygTealiumLib';

const tealium = {
  flowDefault: {
    'page_business_section': '',
    'page_name': '',
    'page_product_name': '',
    'page_type': 'flow',
    'page_site_section': '',
    'purchase_product_name': '',
    'flow_name': '',
    'flow_category': '',
    'flow_group': '',
    'customer_type': '',
    'deployment_instance': '',
  },
  lightboxDefault: {
    'page_type': 'lightbox',
    'page_site_section': '',
    'page_business_section': '',
    'page_name': '',
    'flow_name': '',
    'flow_type': '',
    'deployment_instance': '',
  },
  // This is for pages where the flow is already part the page like webform.
  flowNodeDefault: {
    'flow_name': '',
    'flow_category': '',
    'deployment_instance': '',
  },
  viewDefault: {
    'page_type': '',
    'page_name': '',
    'page_site_section': '',
    'page_business_section': '',
    'page_product_name': '',
    'flow_name': '',
    'flow_category': '',
    'deployment_instance': '',
  },
  overlayDefault: {
    'page_type': 'overlay',
    'page_name': '',
    'page_site_section': '',
    'page_business_section': '',
    'page_product_name': '',
  },
  linkDefault: {
    'link_content_type': '$[page_content_type]',
    'link_content_id': '$[page_content_id]',
  },
  linkMappings: {
    'link_text': '',
    'link_anchor_or_label': '',
    'link_type': '',
    'link_content_type': '',
    'link_content_id': '',
    'error_type': '',
    'error_code': '',
    'error_message': '',
    'error_field_label': '',
  },
  flowWizardDefault: {
    'page_name': '',
    'flow_name': '',
    'flow_step_no': '',
    'deployment_instance': '',
  },
  hash: '',
  flowError: null,
  flowHashData: null,
  leadLinkData: null,
  original: null,
  attach(isMock = false) {
    this.original = this.getClonedUtagData(true);
    this.original.mock = isMock;
  },
  clone(data) {
    return JSON.parse(JSON.stringify(data));
  },
  getClonedUtagData(init) {
    if (init) {
      return this.clone(window.trygTealiumData.tealiumData);
    }
    return this.clone(this.original);
  },
  setUtagData(key, value) {
    if (!window.utag_data) {
      window.utag_data = {};
    }
    window.utag_data[key] = value;
    if (tealium.original !== null) {
      tealium.original[key] = value;
    }
  },
  sendLinkSystemError(response, ignoreUserError) {
    const { errorCodes } = window.trygTealiumData.tealiumData;
    const data = {
      error_code: response.error_code ? response.error_code : response.errorCode,
      error_type: response.error_type ? response.error_type : (response.errorType || 'system error'),
    };
    if (response.error_code !== undefined && response.error_code in errorCodes) {
      data.error_type = errorCodes[response.error_code].type;
    }
    if (response.errorCode !== undefined && response.errorCode in errorCodes) {
      data.error_type = errorCodes[response.errorCode].type;
    }
    if (ignoreUserError && data.error_type === 'user error') {
      return;
    }
    data.custom_event = [data.error_type];
    trygTealiumLib.link(['error'], data, data);
  },
  sendFlowHashPages(data) {
    const keys = ['global', 'customer', 'product', 'checkoutCalculation'];
    return trygTealiumLib.view(keys, this.original, data);
  },
  getHashStepNo(hash) {
    const split = hash.split('-');
    if (split.length < 3) {
      return '';
    }
    return `step${split[0]}.${split[1]}.${split[2]}`;
  },
  processFlowHashPages(hash, tealiumData) {
    if (tealium.hash !== hash) {
      
      // Check if flowHashData is available.
      if (!tealium.flowHashData && window.trygTealiumData) {
        tealium.flowHashData = window.trygTealiumData.flowHashData;
      }
      if (!tealium.flowHashData) {
        return null;
      }
      if (tealium.hash === 'error') {
        // Set flow error late so bmetric will be triggered.
        tealium.sendLinkSystemError(tealium.flowError);
        // Set current hash so we don't send the error again.
        tealium.hash = hash;
        return null;
      }
      const flowStepNo = hash; // tealium.getHashStepNo(hash);
      if (!flowStepNo) {
        return null;
      }
      /* eslint-disable camelcase */
      let data = { flow_step_no: flowStepNo };
      let sent = false;
      if (tealium.flowHashData[flowStepNo] !== undefined) {
        // We clone data so any changes is not updated in the original data.
        data = tealium.clone(tealium.flowHashData[flowStepNo]);
        if (data.noTracking) {
          // We don't want to send tracking data if the page has chosen not to send data.
          sent = true;
        }
      }
      if (!sent) {
        const responseTealiumData = tealium.sendFlowHashPages(tealiumData);
        // Set current hash.
        tealium.hash = hash;
        return responseTealiumData;
      }
    }
    return null;
  },
  initUtagData() {
    window.utag_data = {
      page_name: '',
      tealium_environment: '',
      adobe_analytics_report_suite: '',
      page_division_section: '',
      page_site_section: '',
      page_sub_section: '',
      page_type: '',
      customer_status: '',
      page_content_id: '',
      deployment_instance: '',
      cookie_consent: '',
      widget_type: '',
      url_without_query_string: '',
      custom_event: '',
      flow_group: '',
      error_message: '',
      error_code: '',
      error_type: '',
      product_category: '',
      flow_category: '',
    };
  },
  pushCookieConsent(consent) {
    if (window.utag_data.cookie_consent_approved.indexOf(consent) === -1) {
      window.utag_data.cookie_consent_approved.push(consent);
    }
  },
  initializeUtagCookieConcent() {
    window.utag_data = window.utag_data || {};
    window.utag_data.cookie_consent_approved = window.utag_data.cookie_consent_approved || [];

    // Handle Cookieinformation cookie solution: https://cookieinformation.com/
    if (window.CookieInformation) {
      if (window.CookieInformation.getConsentGivenFor('cookie_cat_necessary')) {
        this.pushCookieConsent('necessary');
      }
      if (window.CookieInformation.getConsentGivenFor('cookie_cat_functional')) {
        this.pushCookieConsent('functional');
      }
      if (window.CookieInformation.getConsentGivenFor('cookie_cat_marketing')) {
        this.pushCookieConsent('marketing');
      }
      if (window.CookieInformation.getConsentGivenFor('cookie_cat_statistics') ||
        window.CookieInformation.getConsentGivenFor('cookie_cat_statistic')) {
        this.pushCookieConsent('statistics');
      }
      // Handle Cookiebot cookie solution: https://www.cookiebot.com/
    } else if (window.Cookiebot && typeof window.Cookiebot.consent === 'object') {
      Object.keys(window.Cookiebot.consent).forEach(key => {
        if (window.Cookiebot.consent[key] === true) {
          this.pushCookieConsent(key);
        }
      });
    }
  },
  checkCookieConsentsAccepted(tealiumEnv) {
    const that = this;
    that.initializeUtagCookieConcent();
    //  window.utag_data.cookie_consent_approved.includes('functional') &&
    if (window.utag_data.cookie_consent_approved &&
      window.utag_data.cookie_consent_approved.includes('marketing') &&
      window.utag_data.cookie_consent_approved.includes('statistics')) {
      window.utag = undefined;
      this.setUtagData('cookie_consent_approved', window.utag_data.cookie_consent_approved);
      this.reloadTealium(tealiumEnv);
    } else {
      setTimeout(() => {
        that.checkCookieConsentsAccepted(tealiumEnv);
      }, 50);
    }
  },
  reloadTealium(tealiumEnv) {
    const allNodes = document.getElementsByTagName(import.meta.env.VITE_WRAPPER_TAG);
    const tealiumSync = import.meta.env.VITE_TEALIUM_SYNC;
    const tealiumURL = `https://tags.tryg.dk/${import.meta.env.VITE_TEALIUM_PROFILE}/${tealiumEnv}`;
    const asyncTealium = `${tealiumURL}/utag.js`;
    if (allNodes[0].shadowRoot) {
      const scriptElement = document.createElement('script');
      scriptElement.src = asyncTealium;
      scriptElement.async = tealiumSync;
      allNodes[0].appendChild(scriptElement);
      if (tealiumSync === 'true') {
        const sync = document.createElement('script');
        sync.src = tealiumSync;
        allNodes[0].appendChild(sync);
      }
    }
  },
};
export const trygTealium = {
  processFlowHashPages: (hash, flowhasData) => {
    return tealium.processFlowHashPages(hash, flowhasData);
  },
  setUtagData: (key, value) => {
    tealium.setUtagData(key, value);
  },
  attach: (isMock) => {
    tealium.attach(isMock);
  },
  initializeCookieConsent: tealium.initializeUtagCookieConcent,
  checkCookieConsentsAccepted: (tealiumEnv) => {
    tealium.checkCookieConsentsAccepted(tealiumEnv);
  },
  initUtagData: tealium.initUtagData,
};
